/**
 * Layout flags for admin shell pages (content editor vs scenario editor vs other admin pages).
 * Used to apply the same content-area CSS classes in AdminPage and AdminPageLoading.
 */
export function getContentEditorAdminLayoutState(location) {
  const isEditScenarioRoute = location.pathname.startsWith(
    "/composer/courses/edit-scenario/"
  );
  const isContentEditorRoute =
    !isEditScenarioRoute &&
    (location.pathname === "/admin" ||
      location.pathname === "/composer" ||
      location.pathname.startsWith("/admin/courses") ||
      location.pathname.startsWith("/composer/courses"));

  return { isEditScenarioRoute, isContentEditorRoute };
}

export function getAdminPageContentClassName({ isEditScenarioRoute, isContentEditorRoute }) {
  return `admin-page-content${
    isContentEditorRoute ? "" : " admin-page-content-with-left-margin"
  }${isEditScenarioRoute ? " admin-page-content-edit-scenario" : ""}`;
}
